import styled from 'styled-components'
import appMobile from './app-mobile.png'
import bodyBg from './body.png'
import bgMobile from './header-bg-mobile.png'
import mobileHeading from './mobile-heading.png'

const mobile = 'max-width: 1000px'

export const Container = styled.section`
  width: 100%;
  max-width: 1300px;
  padding: 0 24px;
  margin: auto;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media only screen and (${mobile}) {
    flex-direction: column-reverse;
    align-items: center;
  }
`

export const CenterContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`

export const VerticalCenterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media only screen and (${mobile}) {
    flex-direction: column;
    justify-content: center;
  }
`

export const Head = styled.div`
  width: 100%;
  padding-bottom: 530px;
  padding-top: 80px;
  background-image: url(${({ bg }) => bg});
  background-size: 1600px;
  background-repeat: no-repeat;
  background-position: center 210px;
  position: relative;
  @media only screen and (${mobile}) {
    background-size: 500px;
    background-position: center calc(100% - 55px);
    padding-bottom: 290px;
    background: none;

    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-image: url(${bgMobile});
      background-size: 100% 100%;
      z-index: -1;
    }
    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 50%;
      top: 0;
      bottom: 0;
      background-image: url(${({ bg }) => bg});
      background-repeat: no-repeat;
      width: 370px;
      background-size: 500px;
      background-position: center calc(100% - 55px);
      z-index: -1;
      transform: translateX(-50%);
    }
  }
`

export const H1 = styled.h1`
  max-width: 926px;
  font-family: Helvetica Neue;
  font-size: 40px;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 0em;
  margin: 0 0 32px;
  text-align: center;

  @media only screen and (${mobile}) {
    font-size: 20px;
    line-height: 30px;
    max-width: 330px;
  }
`

export const H2 = styled.h2`
  font-family: Helvetica Neue;
  font-size: 32px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0 0 24px;
  padding-right: 50px;
  @media only screen and (${mobile}) {
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    padding: 0;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Description = styled.p`
  padding: 0;
  margin: 0 0 32px;
  font-family: Helvetica Neue;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: center;
  max-width: 1027px;

  a {
    color: #ff5e6d;
    text-decoration: underline;
  }

  @media only screen and (${mobile}) {
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    max-width: 330px;
  }
`

const buttonStyles = `
border: 0;
border-radius: 83px;
background: linear-gradient(
  270deg,
  #ff9d74 0%,
  #ff5e6d 37.4%,
  #ff4f7e 74.69%,
  #ff6d90 100%
  );
  color: #fff;
  font-family: Helvetica Neue;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  padding: 14px 69px;
  margin: 0;
  cursor: pointer;
  min-width: 240px;
  
  transition: opacity 0.2s ease;
  
  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)),
    linear-gradient(
      270deg,
      #ff9d74 0%,
      #ff5e6d 37.4%,
      #ff4f7e 74.69%,
      #ff6d90 100%
    );
  }
  
  @media only screen and (${mobile}) {
    font-size: 14px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 20px;
    padding: 0 10px 0 10px;
    min-width: 0;
    margin: 0 auto;
  }
  `
export const Button = styled.button`
  ${buttonStyles}
`
export const ButtonLink = styled.a`
  ${buttonStyles}
`

export const Text = styled.p`
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0;
  margin: 0;

  & a,
  .highlight {
    color: #ff5e6d;
    text-decoration: underline;
  }

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`

export const Body = styled.article`
  background-image: url(${bodyBg});
  padding: 120px 0;
  display: flex;
  flex-direction: column;
  gap: 130px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media only screen and (${mobile}) {
    background: 0;
    padding: 0;
    gap: 45px;
  }
`

export const Content = styled.div`
  width: 572px;
  max-width: 48%;

  & p {
    max-width: 465px;
  }

  @media only screen and (${mobile}) {
    max-width: none;
    width: 100%;
    max-width: 450px;
  }
`

export const Image = styled.img`
  width: 762px;
  max-width: 100%;
  max-height: 577px;
  object-fit: contain;

  @media only screen and (${mobile}) {
    width: 100%;
    max-width: none;
    max-width: 400px;
    margin: auto;
    display: block;
  }
`

export const MobileHeading = styled.div`
  @media only screen and (${mobile}) {
    background: url(${mobileHeading});
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    margin: 0 -24px;
    padding: 48px 24px 20px;
    margin-bottom: 32px;
    width: 100%;
  }
`

export const Show = styled.div`
  display: ${({ on }) => (on === 'mobile' ? 'none' : 'block')};
  @media only screen and (${mobile}) {
    display: ${({ on }) => (on === 'mobile' ? 'block' : 'none')};
  }
`

export const AppContainer = styled(Container)`
  & img {
    max-width: 48%;
  }

  & p {
    margin: 70px 0 !important;
  }
  @media only screen and (${mobile}) {
    padding: 45px 0;
    background-image: url(${appMobile});
    background-size: cover;
    background-position: top;

    & h2 {
      max-width: 312px;
    }
    & p {
      margin: 30px 0 !important;
    }

    & img {
      max-width: 100%;
    }
  }
`
